import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import confirmService from '../services/confirm.service'
import locationService from '../services/location.service'
import locationApi, { LocationData } from '../apis/location.api'
import { ConfirmParams } from '../components/Confirm/Confirm.state'
import { ActionName } from '../components/Actions'
import Card from '../components/Card'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import TableHorizontal, { TableHorizontalData, TableHorizontalHeader } from '../components/TableHorizontal'
import Button from '../components/Button'
import HeadingRow from '../components/HeadingRow'

interface LocationsProps extends RouteComponentProps {}

interface LocationsState {
  locations: TableHorizontalData<LocationData>[]
}

class Locations extends Component<LocationsProps, LocationsState> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n("Location"), path: 'name' },
    { heading: i18n("Capacity"), path: 'capacity' },
    { heading: i18n("Created at"),
      path: 'createdAt',
      date: true,
      tooltip: ['createdUser.username']
    },
    { heading: i18n("Updated at"),
      path: 'updatedAt',
      date: true,
      tooltip: ['updatedUser.username']
    },
    { heading: i18n("Actions") }
  ]

  constructor (props: LocationsProps) {
    super(props)
    this.state = {
      locations: []
    }
    this.handleActionClick = this.handleActionClick.bind(this)
    this.handleCreateClick = this.handleCreateClick.bind(this)
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'edit') {
      const pathname = routes.locationEdit
      const state = { id }
      this.props.history.push({ pathname, state })
    } else if (action === 'delete') {
      const confirm: ConfirmParams = {
        id,
        type: 'warning',
        question: i18n('Are you sure to delete the location?'),
        confirmText: i18n('Yes'),
        cancelText: i18n('No'),
        onConfirm: () => this.handleDeleteConfirm(id)
      }
      confirmService.push(confirm)
    }
  }

  handleDeleteConfirm (id: number) {
    locationApi.delete(id, location => {
      if (!location) return
      const locations = locationService.delete(this.state.locations, id)
      this.setState({ locations })
    })
  }

  handleCreateClick () {
    this.props.history.push(routes.locationCreate)
  }

  listLocations () {
    locationApi.list(locations => {
      if (!locations) return
      const locationData = locationService.tableHorizontalData(locations)
      this.setState({ locations: locationData })
    })
  }

  componentDidMount () {
    this.listLocations()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <Card>
            <HeadingRow
              heading={i18n("Locations")}
              doc='locations'>
              <Button
                text={i18n("Create")}
                onClick={this.handleCreateClick} />
            </HeadingRow>
            <TableHorizontal
              headers={this.headers}
              data={this.state.locations}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(Locations)
